import { render, staticRenderFns } from "./ShopsFiltersModal.vue?vue&type=template&id=59fd151a&"
import script from "./ShopsFiltersModal.vue?vue&type=script&lang=js&"
export * from "./ShopsFiltersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports